const BXS_URL_SCHEME_PREFIX = 'bxs://common/open/mp'

function getFallbackUrlFromUrlSchemes(urlScheme) {
    if (! typeof urlScheme === 'string' || !urlScheme.indexOf(BXS_URL_SCHEME_PREFIX) === 0) {
        return
    }
    // 当前仅能猜测，自定义中转页使用小程序，且小程序打开内嵌 webview 时，其对应 URL 或可在 PC 端打开。
    try {
        const [_, webUrlParts] = urlScheme.split('path=%2Fpages%2Fwebview%2Findex%3FtoUrl%3D')
        if (webUrlParts) {
            const result = decodeURIComponent(webUrlParts)
            return result
        }
    } catch(e) {}
}

export function getPcCompatibleUrl(url) {
    if (typeof url !== 'string') {
        return
    }
    const rawUrl = url.trim()
    if (/^https?:\/\//.test(rawUrl)) {
        return rawUrl
    }
    return getFallbackUrlFromUrlSchemes(rawUrl)
}


// WEBPACK FOOTER //
// ./src/util/url.js